import * as types from "./visitorTypes";

//FOR FETCHING SITES
// export const fetchVisitorRequest = () => (
//     {
//     type: types.FETCH_VISITOR_REQUEST,
// });
export const fetchVisitorRequest = (params) => ({
    type: types.FETCH_VISITOR_REQUEST,
    payload: params, 
});

export const fetchVisitorSuccess = (data) => (
    ////console.log(data),
    {
    type: types.FETCH_VISITOR_SUCCESS,
    payload: data,
});

export const fetchVisitorFailure = (error) => ({
    type: types.FETCH_VISITOR_FAILURE,
    payload: error,
});

//FOR ADDING SITES
export const addVisitorRequest = (data) => ({
    type: types.ADD_VISITOR_REQUEST,
    payload: data,
  });
  
  export const addVisitorSuccess = (data) => ({
    type: types.ADD_VISITOR_SUCCESS,
    payload: data,
  });
  
  export const addVisitorFailure = (error) => ({
    type: types.ADD_VISITOR_FAILURE,
    payload: error,
  });

  //FOR UPDATING VISITORS
export const updateVisitorRequest = (updatedVisitor) => ({
    type: types.UPDATE_VISITOR_REQUEST,
    payload: updatedVisitor,
});

export const updateVisitorSuccess = (updatedVisitor) => ({
    type: types.UPDATE_VISITOR_SUCCESS,
    payload: updatedVisitor,
});

export const updateVisitorFailure = (error) => ({
    type: types.UPDATE_VISITOR_FAILURE,
    payload: error,
});

//FOR DELETING VISITORS(visitor out)
export const deleteVisitorRequest = (visitor,id ) => (
    ////console.log(id),
    {
    type: types.DELETE_VISITOR_REQUEST,
    payload: visitor,
});


export const deleteVisitorSuccess = (id) => (
    ////console.log(id),
    {
    type: types.DELETE_VISITOR_SUCCESS,
    payload: id,
});


export const deleteVisitorFailure = (error) => ({
    type: types.DELETE_VISITOR_FAILURE,
    payload: error,
});


